<template>
  <HXContentCard title="Editar Centro de Operacion" :toBack="{ name: 'CentrosDeOperacion' }">
    <form @submit.prevent="saveData">
      <div class="row px-5 mt-4">
        <div class="col-md-6">
          <div>
            <label class="form-label">
              Nombre Centro de Operacion
            </label>
            <input v-model="item.descripcion" required placeholder="Escriba el Nombre del Centro de Operacion..."
              type="text" class="form-control" />
          </div>
        </div>

        <div class="col-md-6">
          <div class="mb-3">
            <label class="form-label">Area</label>
            <b-form-select required v-model="item.areaId" :options="ListAreas" text-field="descripcion"
              value-field="id" />
          </div>
        </div>
      </div>

      <div class="text-right px-5 pb-4 d-flex justify-content-end">
        <vs-button icon animation-type="vertical" type="submit">
          <i class="fas fa-save pr-1"></i>
          Actualizar Centro de Operacion
          <template #animate>
            <i class="fas fa-save"></i>
          </template>
        </vs-button>
      </div>
    </form>
  </HXContentCard>
</template>

<script>
export default {
  data() {
    return {
      item: {
        descripcion: "",
        areaId: "",
        empresaId: "",
        estado: 1,
      },
      ListAreas: [],
      isCreating: false,
      usuario: { rol: { nivel: 0 } },
      id: "",
    };
  },

  async mounted() {
    try {
      this.$isLoading(true);

      this.id = this.$route.params.id;
      this.usuario = JSON.parse(localStorage.getItem("setPersonaAct"));

      await this.getData();

      // Validamos que empresaId exista antes de llamar áreas
      if (this.item.empresaId) {
        await this.getAreas();
      }

    } catch (error) {
      console.log("Error en mounted:", error);
    } finally {
      this.$isLoading(false);
    }
  },

  methods: {
    async getData() {
      try {
        const res = await this.$store.dispatch("hl_get", {
          path: "CentroOperacion/Get/" + this.id,
        });

        this.item = res.data ?? res;

        // Normalizamos areaId para evitar problema de comparación
        if (this.item.areaId) {
          this.item.areaId = this.item.areaId.toString();
        }

        console.log("Centro Operacion:", this.item);

      } catch (error) {
        console.log("Error getData:", error);
        this.item = {};
      }
    },

    async getAreas() {
      try {
        const res = await this.$store.dispatch("hl_get", {
          path: "Area/ListArea/" + this.item.empresaId,
        });

        // Si tu store devuelve directamente el array
        let areas = res.data ?? res ?? [];

        // Normalizamos IDs a string para que el select funcione
        this.ListAreas = areas.map(a => ({
          ...a,
          id: a.id.toString()
        }));

        console.log("Areas cargadas:", this.ListAreas);

      } catch (error) {
        console.log("Error getAreas:", error);
        this.ListAreas = [];
      }
    },

    async saveData() {
      this.isCreating = true;

      try {
        const payload = {
          id: this.item.id,
          descripcion: this.item.descripcion,
          areaId: this.item.areaId,
          estado: this.item.estado,
          empresaId: this.item.empresaId,
        };

        const res = await this.$store.dispatch("hl_put", {
          path: "CentroOperacion/Update",
          data: payload,
        });

        if (res?.success) {
          this.$vs.notification({
            color: "success",
            title: "Éxito",
            text: "Centro de Operacion actualizado correctamente",
            position: "top-right",
          });

          this.$router.push({ name: "CentrosDeOperacion" });
        }

      } catch (error) {
        console.log("Error saveData:", error.response?.data);

        this.$vs.notification({
          color: "danger",
          title: "Error",
          text: "No se pudo actualizar el Centro de Operacion",
          position: "top-right",
        });

      } finally {
        this.isCreating = false;
      }
    },
  },
};
</script>